import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import { Grid } from "@mantine/core";
import { Control, Controller } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import SelectMembershipType from "@/components/molecules/SelectInputs/SelectMembershipType";

interface MembershipTypeProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const MembershipType: React.FC<MembershipTypeProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading" mt={20}>
        {t("registerCompany:membershipType.title")}
      </Text>
      <Grid>
        {/*<Grid.Col span={1} pr={0} mr={0}>*/}
        {/*  <SVGAsset name="circle-questionmark" />*/}
        {/*</Grid.Col>*/}
        {/*<Grid.Col span={10} pl={0} ml={0}>*/}
        {/*  <Text size="sm" color="secondary">*/}
        {/*    {t("registerCompany:membershipType.reason")}*/}
        {/*  </Text>*/}
        {/*</Grid.Col>*/}
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Controller
          name="partialCompany.membershipType"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <SelectMembershipType
              data-testid={"membership-type-select"}
              required
              label={t("registerCompany:membershipType.membershipType")}
              onChange={onChange}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              value={value}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default MembershipType;
